module.exports = __webpack_public_path__ + "static/media/26UNRWA20.79232a80.jpg";